/**
 *  @class
 *  @function BackToTop
 *  Shows as soon as the page has been scrolled a little (SHOW_AFTER px), hides again at the top.
 */
if (!customElements.get('back-to-top')) {
	class BackToTop extends HTMLElement {

		connectedCallback() {
			this.ticking = false;
			this.showAfter = 120;
			this._onScroll = this.checkVisible.bind(this);

			this.addEventListener('click', this.onClick);
			this.addEventListener('touchstart', this.onClick, { passive: true });
			window.addEventListener('scroll', this._onScroll, { passive: true });
			this.checkVisible();
		}

		disconnectedCallback() {
			window.removeEventListener('scroll', this._onScroll);
		}

		checkVisible() {
			if (this.ticking) return;
			this.ticking = true;
			window.requestAnimationFrame(() => {
				this.classList.toggle('back-to-top--active', window.scrollY > this.showAfter);
				this.ticking = false;
			});
		}

		onClick() {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth"
			});
		}
	}
	customElements.define('back-to-top', BackToTop);
}
